import { UnderwritingActivitySearchParams } from '@lio/api-types';

export const getUnderwritingActivityQuery = (params: UnderwritingActivitySearchParams) => {
  const {
    quoteId,
    underwritingActivityTypeId,
    resolvedByUserId,
    createdByUserId,
    isResolved,
    sort,
    pageLimit,
    pageOffset,
  } = params;
  const query = new URLSearchParams();
  if (quoteId) {
    query.append('quoteId', quoteId);
  }
  if (underwritingActivityTypeId) {
    query.append('underwritingActivityTypeId', underwritingActivityTypeId);
  }
  if (resolvedByUserId) {
    query.append('resolvedByUserId', resolvedByUserId);
  }
  if (createdByUserId) {
    query.append('createdByUserId', createdByUserId);
  }
  if (isResolved) {
    query.append('isResolved', isResolved.toString());
  }
  if (sort) {
    query.append('sort', sort);
  } else {
    query.append('sort', '-createdAt');
  }
  if (pageLimit) {
    query.append('pageLimit', pageLimit.toString());
  }
  if (pageOffset) {
    query.append('pageOffset', pageOffset.toString());
  }
  return query.toString();
};
